import { render, staticRenderFns } from "./HubSidebar.vue?vue&type=template&id=4f65e754&"
import script from "./HubSidebar.vue?vue&type=script&lang=js&"
export * from "./HubSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HubSidebar.vue?vue&type=style&index=0&id=4f65e754&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports